export default __webpack_public_path__ + "static/media/FinanceRealCase2-sc.f997257c.jpg";